import React, {ChangeEvent, FormEvent, useEffect, useState} from "react";
import Form from "../../../components/common/form/Form";
import Modal from "../../../components/common/form/Modal";
import InputField from "../../../components/common/form/InputField";
import {OptionType} from "../../../helpers/utils/StyleUtils";
import ButtonTray from "../../../components/common/form/ButtonTray";
import {useAddIncidentMutation, useGetIncidentByIdQuery, useUpdateIncidentMutation} from "../productsApi";
import {createOptionListForSelectTag} from "../../../helpers/utils/Utils";
import SelectField from "../../../components/common/form/SelectField";
import {useGetEnumsQuery} from "../../../app/globalApi";
import TextAreaField from "../../../components/common/form/TextAreaField";
import {formatValueAsDate, formatIsoDateString} from "../../../helpers/utils/DateUtils";
import {useGetOrderByOrderIdAndTypeQuery} from "../ordersApi";
import {
    useGetAllAssigneesByUserIdQuery,
    useLazyGetAllUserListByCustomerIdQuery,
    useLazyGetTenantCustomerByTenantQuery
} from "../../user/users/usersApi";
import {skipToken} from "@reduxjs/toolkit/query";
import {useLazyGetAllCustomerByTenantQuery} from "../../customer/customerApi";
import {useUtilDataQuery} from "../../profile/profileApi";

interface IncidentProps {
    show: boolean;
    setShow: (show: boolean) => void;
    title?: any,
    btnText?: any,
    incidentId?: any
    orderId?: any
}

const IncidentModal: React.FC<IncidentProps> = ({
                                                    show,
                                                    setShow,
                                                    title,
                                                    btnText,
                                                    incidentId,
                                                    orderId
                                                }) => {
    const [updateIncident, updateIncidentRes] = useUpdateIncidentMutation();
    const [addIncident, addIncidentRes] = useAddIncidentMutation();
    const {
        data: orderData,
    } = useGetOrderByOrderIdAndTypeQuery({orderId: orderId, orderType: 'OTHER' ?? skipToken});
    const {data: incidentById} = useGetIncidentByIdQuery(incidentId ?? skipToken);
    const [incident, setIncident] = useState<any>();
    const {data: enums} = useGetEnumsQuery("");
    const [customerByTenantApi, customerByTenantRes] = useLazyGetTenantCustomerByTenantQuery();
    const [customerList, customerListRes] = useLazyGetAllCustomerByTenantQuery();
    const [userListByCustomerApi, reportingCustomerUserListResponse] = useLazyGetAllUserListByCustomerIdQuery();
    const validResponsibleUsers = useGetAllAssigneesByUserIdQuery(orderId ?? skipToken);
    const {data: utilData} = useUtilDataQuery("")

    useEffect(() => {
        customerList({tenantName: utilData?.tenant});
        customerByTenantApi(utilData?.tenant);
    }, [utilData]);

    useEffect(() => {
        if (incidentById) {
            setIncident({
                ...incidentById,
                reportingUser: incidentById?.reportingUser ? {
                    label: reportingCustomerUserListResponse?.data?.find((e: any) => e.id === incidentById?.reportingUser)?.username,
                    value: incidentById?.reportingUser
                } : null,
                responsibleUser: incidentById?.responsibleUser ? {
                    label: validResponsibleUsers?.data?.find((e: any) => e.id === incidentById?.responsibleUser)?.username,
                    value: incidentById?.responsibleUser
                } : null,
                reportingParty: {
                    label: customerListRes?.data?.find((e: any) => e.id === incidentById?.reportingParty)?.customerName,
                    value: orderData?.customerDTO?.id
                },
                responsibleParty: {
                    label: customerListRes?.data?.find((e: any) => e.id === incidentById?.responsibleParty)?.customerName,
                    value: customerByTenantRes?.data?.id
                }
            });
        }

    }, [incidentById, reportingCustomerUserListResponse?.data, customerListRes?.data]);

    useEffect(() => {
        if (!incidentById) {
            setIncident({
                ...incidentById,
                reportingParty: orderData?.customerDTO?.customerName?{
                    label: customerListRes?.data?.find((e: any) => e.customerName === orderData?.customerDTO?.customerName)?.customerName,
                    value: orderData?.customerDTO?.id
                }:null,
                responsibleParty: customerByTenantRes?.data?.customerName?{
                    label: customerListRes?.data?.find((e: any) => e.customerName === customerByTenantRes?.data?.customerName)?.customerName,
                    value: customerByTenantRes?.data?.id
                }:null
            })
        }
    }, [orderData, customerListRes?.data]);

    useEffect(() => {
        if (orderData?.customerDTO){
            userListByCustomerApi(incident?.reportingParty?.value || orderData?.customerDTO?.id);
            customerList({tenantName: orderData?.customerDTO?.tenant});
            customerByTenantApi(orderData?.customerDTO?.tenant);
        }

    }, [orderData, incident]);
    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        const payload = {
            type: incident?.type || null,
            severity: incident?.severity || null,
            claim: incident?.claim || null,
            occurredDate: incident?.occurredDate || null,
            reportedDate: incident?.reportedDate || null,
            resolutionDate: incident?.resolutionDate || null,
            claimAmount: incident?.claimAmount || "",
            paidAmount: incident?.paidAmount || "",
            description: incident?.description || "",
            productId: incident?.productId || "",
            reportingParty: orderData?.customerDTO?.id,
            reportingUser: incident?.reportingUser?.value || "",
            responsibleParty: customerByTenantRes?.data?.id,
            responsibleUser: incident?.responsibleUser?.value || "",
            tenant: orderData.tenant,
        };

        if (btnText !== "Update") {
            await addIncident(
                payload
            );
            setShow(false);
        } else {
            await updateIncident({
                id: incidentId, requestBody: payload
            });
            setShow(false);
        }
    };

    const handleOnChange = (e: ChangeEvent<HTMLInputElement> | { name: string; value: OptionType | null }) => {
        const {name, value} = "target" in e ? e.target : e;
        setIncident({
            ...incident,
            [name]: value
        })
    }

    return (
        <Modal
            title={title}
            show={show}
            setShow={setShow}
            className="w-2/5  bg-text-0 rounded-lg shadow-lg"
            fields={
                <Form onSubmit={handleSubmit} fields={
                    <div className=" ">
                        <SelectField
                            placeholder="Select Product..."
                            value={
                                orderData?.products?.find((p: any) => p.id === incident?.productId)
                                    ? {
                                        label: orderData.products.find((p: any) => p.id === incident.productId)?.type,
                                        value: orderData.products.find((p: any) => p.id === incident.productId)?.id
                                    }
                                    : null
                            }
                            options={
                                orderData?.products?.map((product: any) => ({
                                    label: product.type,
                                    value: product.id
                                })) || []
                            }
                            onChange={(selectedOption) => {
                                handleOnChange({name: "productId", value: selectedOption?.value});
                            }}
                            label="Product"
                            required
                        />

                        <SelectField
                            placeholder="Select Type..."
                            label="Type"
                            required
                            value={
                                enums?.["IncidentType"]?.find((item: any) => item.constant === incident?.type)
                                    ? {
                                        label: enums["IncidentType"].find((item: any) => item.constant === incident.type).value,
                                        value: incident.type
                                    }
                                    : null
                            }
                            options={createOptionListForSelectTag(enums?.["IncidentType"], "value", "constant")}
                            onChange={(selectedOption) => {
                                handleOnChange({name: "type", value: selectedOption?.value});
                            }}
                        />
                        <SelectField
                            placeholder="Select Severity..."
                            label="Severity"
                            required
                            value={
                                enums?.["IncidentSeverity"]?.find((item: any) => item.constant === incident?.severity)
                                    ? {
                                        label: enums["IncidentSeverity"].find((item: any) => item.constant === incident.severity).value,
                                        value: incident.severity
                                    }
                                    : null
                            }
                            options={createOptionListForSelectTag(enums?.["IncidentSeverity"], "value", "constant")}
                            onChange={(selectedOption) => {
                                handleOnChange({name: "severity", value: selectedOption?.value});
                            }}
                        />

                        <SelectField
                            placeholder="Select Claim..."
                            label="Claim"
                            required
                            value={
                                incident?.claim === true
                                    ? {label: "Yes", value: true}
                                    : incident?.claim === false
                                        ? {label: "No", value: false}
                                        : null
                            }
                            options={[
                                {label: "Yes", value: true},
                                {label: "No", value: false}
                            ]}
                            onChange={(selectedOption) => {
                                handleOnChange({name: "claim", value: selectedOption?.value});
                            }}
                        />

                        <SelectField
                            placeholder="Select Reporting Party..."
                            label="Reporting Party"
                            value={incident?.reportingParty}
                            options={createOptionListForSelectTag(customerListRes.data, "customerName", "id")}
                            onChange={(selectedOption) => {
                                handleOnChange({name: "reportingParty", value: selectedOption});
                            }}
                            required={true}
                        />
                        <SelectField
                            placeholder="Select Reporting User..."
                            label="Reporting User"
                            value={incident?.reportingUser}
                            options={createOptionListForSelectTag(reportingCustomerUserListResponse.data, "username", "id")}
                            onChange={(selectedOption) => {
                                handleOnChange({name: "reportingUser", value: selectedOption});
                            }}
                        />


                        <SelectField
                            placeholder="Select Responsible Party..."
                            label="Responsible Party"
                            value={incident?.responsibleParty}
                            options={createOptionListForSelectTag(customerListRes.data, "customerName", "id")}
                            onChange={(selectedOption) => {
                                handleOnChange({name: "responsibleParty", value: selectedOption});
                            }}
                            required={true}
                        />

                        <SelectField
                            placeholder="Select Responsible User..."
                            label="Responsible User"
                            value={incident?.responsibleUser}
                            options={createOptionListForSelectTag(validResponsibleUsers?.data, "username", "id")}
                            onChange={(selectedOption) => {
                                handleOnChange({name: "responsibleUser", value: selectedOption});
                            }}
                        />

                        <InputField
                            label="Occurence Date"
                            value={formatValueAsDate(incident?.occurredDate, "YYYY-MM-DD") || ""}
                            placeholder="Enter Occurence Date..."
                            type="date"
                            name={"occurredDate"}
                            onChange={handleOnChange}
                            required={true}
                            className={`${!incident?.occurredDate ? "text-text-2" : ""}`}

                        />
                            <InputField
                            label="Reported Date"
                            value={formatValueAsDate(incident?.reportedDate, "YYYY-MM-DD") || ""}
                            placeholder="Enter Reported Date..."
                            type="date"
                            name={"reportedDate"}
                            onChange={handleOnChange}
                            required={true}
                            className={`${!incident?.reportedDate ? "text-text-2" : ""}`}
                        />

                        <InputField
                            label="Resolution Date"
                            value={formatValueAsDate(incident?.resolutionDate, "YYYY-MM-DD") || ""}
                            placeholder="Enter Resolution Date..."
                            type="date"
                            name="resolutionDate"
                            onChange={handleOnChange}
                            required={false}
                            className={`${!incident?.resolutionDate ? "text-text-2" : ""}`}
                        />


                        {incident?.claim &&
                            <>
                                <InputField
                                    label="Claim Amount"
                                    name="claimAmount"
                                    value={incident?.claimAmount || ""}
                                    type="double"
                                    onChange={handleOnChange}
                                    className="mb-2"
                                    required={incident?.claim}
                                />

                                <InputField
                                    label="Paid Amount"
                                    name="paidAmount"
                                    value={incident?.paidAmount || ""}
                                    onChange={handleOnChange}
                                    className="mb-2"
                                    type="double"
                                />
                            </>

                        }

                        <InputField
                            label="Dev Ticket Reference"
                            name="devTicketReference"
                            value={incident?.devTicketReference || ""}
                            type="text"
                            onChange={handleOnChange}
                            className="mb-2"
                        />

                        <InputField
                            label="Dev Ticket Date"
                            value={formatValueAsDate(incident?.devTicketDate, "YYYY-MM-DD") || ""}
                            placeholder="Enter Resolution Date..."
                            type="date"
                            name={"resolutionDate"}
                            onChange={handleOnChange}
                            required={false}
                            className={`${!incident?.devTicketDate ? "text-text-2" : ""}`}
                        />

                        <TextAreaField
                            label="Description"
                            name="description"
                            value={incident?.description || ""}
                            onChange={(e: any) => handleOnChange(e)}
                            className="mb-2 text-surface-2"
                            required={true}

                        />


                        <div className={'mt-4 border-t border-t-surface-5 flex justify-end'}>
                            <ButtonTray
                                buttons={[
                                    {
                                        buttonProps: {
                                            btnText: "Cancel",
                                            onClick: () => setShow(false),
                                            type: "close",
                                        },
                                        buttonType: "button"
                                    },
                                    {
                                        buttonProps: {
                                            btnText: btnText,
                                            isLoading: updateIncidentRes.isLoading || addIncidentRes.isLoading,
                                            type: "submit",
                                        },
                                        buttonType: "button"
                                    },

                                ]}
                                align={"start"}
                                gap={2}
                            />
                        </div>


                    </div>
                }/>

            }


        />
    )
};

export default IncidentModal;